import { useCallback, useEffect, useState } from 'react'
import { Form } from 'react-bootstrap'
import { useDispatch } from 'react-redux'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** STYLE */
import useStyles from 'features/setting/default-users/patient-types/style'

/** API */
import PatientTypeApi from 'api/setting/default-users/patient-type.api'

/** UTILS || SLICE */
import { submitModal, unSubmitModal, resetModal } from 'app/slice/modal.slice'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

/** COMPONENT */
import HeaderCard from 'component/CardCustom/HeaderCard'
import TableCustom from 'component/Table/TableCustom'
import { notiSuccess } from 'component/notifications/notifications'
import TableRowCommon from 'component/Table/TableRowCommon'
import AlertModal from 'new-components/modal/alert-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'
import PageModal from 'new-components/modal/page-modal'
import TextInput from 'new-components/inputs/text-input'
import SwitchButton from 'new-components/buttons/switch-button'
import { Box, Grid } from '@mui/material'
import SelectInput from 'new-components/inputs/select-input'
import OperativeTypeApi from 'api/setting/treatments/operative-type.api'
import _ from 'lodash'
import OperativeApi from 'api/setting/treatments/operative.api'
import MainButton from 'new-components/buttons/main-button'
import AddCircleIcon from '@mui/icons-material/AddCircle'

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}

const initStateErrorMessage = {
  PATIENT_TYPE_NAME: ``,
  IS_DUPLICATE_PATIENT_TYPE_NAME: ``,
  PATIENT_TYPE_NAME_STRING_BASE: ``,
  PATIENT_TYPE_NAME_STRING_EMPTY: ``,
  PATIENT_TYPE_NAME_MAXIMUM_LENGTH: ``,
  PATIENT_TYPE_NAME_ANY_REQUIRED: ``,

  PATIENT_TYPE_NAME_EN: ``,
  IS_DUPLICATE_PATIENT_TYPE_NAME_EN: ``,
  PATIENT_TYPE_NAME_EN_STRING_BASE: ``,
  PATIENT_TYPE_NAME_EN_STRING_EMPTY: ``,
  PATIENT_TYPE_NAME_EN_MAXIMUM_LENGTH: ``,
  PATIENT_TYPE_NAME_EN_ANY_REQUIRED: ``,

  OPERATIVE_TYPE: "",
  OPERATIVE: "",
  VISITCOUNT: "",
}
export default function PatientTypes() {
  const classes = useStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [patientTypes, setPatientTypes] = useState([])

  const [patientTypeId, setPatientTypeId] = useState(Number)
  const [patientTypeName, setPatientTypeName] = useState('')
  const [patientTypeNameEn, setPatientTypeNameEn] = useState('')
  const [patientTypeStatus, setPatientTypeStatus] = useState('')

  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  /** PAGINATION  */
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')

  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [nameEn, setNameEn] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')

  const [isPopup, setIsPopup] = useState(false)
  const [hasCondition, setHasCondition] = useState('0')
  const [operativeTypes, setOperativeTypes] = useState([])
  const [operative, setOperative] = useState([])
  const [dataOperativeTypes, setDataOperativeTypes] = useState('')
  const [dataOperative, setDataOperative] = useState('')
  const [visitCount, setVisitCount] = useState(null)
  const [conditions, setConditions] = useState('')


  const loadData = async () => {

    let condition: any = {}
    if (page) condition = { ...condition, page: page }
    if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
    if (search) condition = { ...condition, search: search }
    if (sortBy) condition = { ...condition, sortBy: sortBy }
    if (sortType) condition = { ...condition, sortType: sortType }
    if (status) condition = { ...condition, status: status === 'ALL' ? '' : status }
    if (conditions) condition = { ...condition, hasCondition: conditions }

    const res = await PatientTypeApi.findAll(condition)
    if (res.status === 200) {
      setRowCount(res.headers['x-total'])
      setPatientTypes(res.data)
    }
  }

  const loadOperativeType = useCallback(async () => {
    const resp = await OperativeTypeApi.findAll({ pageLimit: 999 })
    if (resp.status === 200) {
      setOperativeTypes(resp.data)
    } else {
      setOperativeTypes([])
    }
  }, [])

  const loadOperative = async (id: number) => {
    const resp = await OperativeApi.findAll({ operativeTypeId: id, pageLimit: 999 })
    if (resp.status === 200) {
      setOperative(resp.data)
    } else {
      setOperative([])
    }
  }

  useEffect(() => {
    loadData()
  }, [page, pageLimit, sortBy, sortType])

  useEffect(() => {
    loadOperativeType()
  }, [])

  const submit = () => {
    if (hasCondition === "1") {
      if (!patientTypeName || !dataOperativeTypes || !dataOperative || !visitCount || visitCount === '0' || visitCount === 0) {
        return setErrorMessage({
          ...errorMessage, ...{
            PATIENT_TYPE_NAME: !patientTypeName ? t('PATIENT_TYPE.MESSAGE.PATIENT_TYPE_NAME') : '',
            OPERATIVE_TYPE: hasCondition === "1" ? !dataOperativeTypes ? 'กรุณาเลือก ประเภทหัตถการ' : '' : '',
            OPERATIVE: hasCondition === "1" ? dataOperativeTypes ? !dataOperative ? 'กรุณาเลือก รายการหัตถการ' : '' : '' : "",
            VISITCOUNT: hasCondition === '1' ? dataOperative ? (!visitCount || visitCount === "0" || visitCount === 0) ? "กรุณาใส่ จำนวน" : "" : "" : ""
          }
        })
      }
    }
    dispatch(submitModal())
    PatientTypeApi.create({
      patientTypeName: patientTypeName,
      patientTypeNameEn: patientTypeNameEn,
      hasCondition: hasCondition,
      itemId: Number(dataOperative),
      itemTypeId: Number(dataOperativeTypes),
      visitCount: Number(visitCount)
    })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t('PATIENT_TYPE.MESSAGE.SUCCESS.CREATE'), '', null, null)
          resetForm()

          loadData()
          dispatch(resetModal())
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`PATIENT_TYPE.MESSAGE.${err.message}`) } })
          dispatch(unSubmitModal())
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`PATIENT_TYPE.MESSAGE.${err.message}`) } })
        dispatch(unSubmitModal())
      })
  }

  const submitEdit = () => {
    if (hasCondition === "1") {
      if (!patientTypeName || !dataOperativeTypes || !dataOperative || !visitCount || visitCount === '0' || visitCount === 0) {
        return setErrorMessage({
          ...errorMessage, ...{
            PATIENT_TYPE_NAME: !patientTypeName ? t('PATIENT_TYPE.MESSAGE.PATIENT_TYPE_NAME') : '',
            OPERATIVE_TYPE: hasCondition === "1" ? !dataOperativeTypes ? 'กรุณาเลือก ประเภทหัตถการ' : '' : '',
            OPERATIVE: hasCondition === "1" ? dataOperativeTypes ? !dataOperative ? 'กรุณาเลือก รายการหัตถการ' : '' : '' : "",
            VISITCOUNT: hasCondition === '1' ? dataOperative ? (!visitCount || visitCount === '0' || visitCount === 0) ? "กรุณาใส่ จำนวน" : "" : "" : ""
          }
        })
      }
    }

    dispatch(submitModal())
    PatientTypeApi.update(patientTypeId, {
      patientTypeName: patientTypeName,
      patientTypeNameEn: patientTypeNameEn,
      hasCondition: hasCondition,
      itemId: Number(dataOperative),
      itemTypeId: Number(dataOperativeTypes),
      visitCount: Number(visitCount),
      status: patientTypeStatus
    })
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          notiSuccess(t(`PATIENT_TYPE.MESSAGE.SUCCESS.UPDATE`), '', null, null)
          resetForm()
          loadData()
          dispatch(resetModal())
        } else {
          const err = res.response.data

          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`PATIENT_TYPE.MESSAGE.${err.message}`) } })
          dispatch(unSubmitModal())
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`PATIENT_TYPE.MESSAGE.${err.message}`) } })
        dispatch(unSubmitModal())
      })
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const resetForm = () => {
    setPatientTypeId(0)
    setPatientTypeName('')
    setPatientTypeNameEn('')
    setPatientTypeStatus('')
    setHasCondition('0')
    setDataOperative('')
    setDataOperativeTypes('')
    setVisitCount(null)
    setIsPopup(false)
    clearErrorMessage()
  }

  const onActive = () => {
    if (id) {
      PatientTypeApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('PATIENT_TYPE.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('PATIENT_TYPE.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = () => {
    if (id) {
      PatientTypeApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('PATIENT_TYPE.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('PATIENT_TYPE.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {
    const { patientTypeId: ptTypeId, patientTypeName: ptTypeName, patientTypeNameEn: ptTypeNameEn, status: ptTypeStatus } = data
    setPatientTypeId(ptTypeId)
    setPatientTypeName(ptTypeName)
    setPatientTypeNameEn(ptTypeNameEn)
    setPatientTypeStatus(ptTypeStatus)
    setDataOperativeTypes(data.itemTypeId)
    setDataOperative(data.itemId)
    setVisitCount(data.visitCount)
    setHasCondition(data.hasCondition)
    setIsPopup(true)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }
  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }
  const headCells = [
    { id: 'no', disablePadding: false, label: '#' },
    { id: 'patientTypeName', disablePadding: false, label: t('PATIENT_TYPE.TABLE.CELL.PATIENT_TYPE_NAME') },
    { id: 'patientTypeNameEn', disablePadding: false, label: t('PATIENT_TYPE.TABLE.CELL.PATIENT_TYPE_NAME_EN') },
    { id: 'condition', disablePadding: false, label: t('PATIENT_TYPE.TABLE.CELL.CONDITION') },
    { id: 'status', disablePadding: false, label: t('PATIENT_TYPE.TABLE.CELL.STATUS') },
    { id: 'updatedBy', disablePadding: false, label: t('PATIENT_TYPE.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { patientTypeId: ptTypeId, patientTypeName: ptTypeName, patientTypeNameEn: ptTypeNameEn, updatedBy, updatedAt, status: ptTypeStatus } = objData
    const statusBtnActive = ptTypeStatus === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = ptTypeStatus === 'INACTIVE' ? true : permissions.isUpdate.disabled
    const objRenderData = {
      key: ptTypeId,
      id: ptTypeId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: ptTypeName },
        { option: 'TEXT', align: 'left', label: ptTypeNameEn },
        { option: 'TEXT', align: 'left', label: objData?.hasCondition === "0" ? 'ไม่มีเงื่อนไข' : objData?.hasCondition === "1" ? 'เงื่อนไขอัตโนมัติตามจำนวนครั้งหัตถการ' : '-' },
        { option: 'STATUS', align: 'center', label: ptTypeStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
        onedit={() => {
          loadOperative(objRenderData.obj?.itemTypeId)
          onEdit(objRenderData.obj)
        }}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.patientTypeName)
    setNameEn(obj.patientTypeNameEn)
  }

  return (
    <div className={classes.root}>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`PATIENT_TYPE.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`PATIENT_TYPE.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { patientTypeName: name, patientTypeNameEn: nameEn && `(${nameEn})`, status: t(`PATIENT_TYPE.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <HeaderCard text={t('PATIENT_TYPE.TITLE')} />
      <Box padding="16px">
        <Grid container spacing="16px">
          <Grid item xs={2} >
            <TextInput
              label={t('PATIENT_TYPE.SEARCH')}
              value={search}
              onChange={(event) => {
                setSearch(event.target.value)
                setPage(1)
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={2} >
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeStatus(value)
                  setPage(1)
                }
              }}
              options={[
                { value: 'ALL', name: t('STATUS.ALL') },
                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                { value: 'INACTIVE', name: t('STATUS.INACTIVE') },
              ]}
              value={status}
              label={t('STATUS.LABEL')}
            />
          </Grid>
          <Grid item xs={2} >
            <SelectInput
              onChange={(e) => setConditions(e.target.value)}
              options={[
                { value: 'ALL', name: t('STATUS.ALL') },
                { value: '0', name: 'ไม่มีเงื่อนไข' },
                { value: '1', name: 'เงื่อนไขอัตโนมัติตามจำนวนครั้งหัตถการ' },
              ]}
              label='เงื่อนไขเพิ่มเติม'
              value={conditions}
            />
          </Grid>
          <Grid item xs={6}>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <MainButton
                title='ค้นหา'
                type='primary'
                variant='contained'
                onClick={() => loadData()}
                style={{ width: '120px' }}
              />
              <MainButton
                title={t('PATIENT_TYPE.BUTTON.ADD')}
                type='primary'
                variant='contained'
                onClick={() => {
                  resetForm()
                  setIsPopup(true)
                }}
                startIcon={<AddCircleIcon />}
              />
            </Box>
          </Grid>
        </Grid>

        <Box marginTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={patientTypes.map((val, i) => {
              return renderData(val, i)
            })}
          />
        </Box>
      </Box>
      {/* <Card className="border-0 h-100">
        <HeaderCard text={t('PATIENT_TYPE.TITLE')} />
        <Card.Body>
          <Card.Title className={'mb-0 pl-xl-3'}>
            <Row className="align-items-center">
              <Col md={8}>
                <Row className="">
                  <Col sm={12} md={6} xl={4} className="pt-2">
                    <InputTextSearch
                      keyInput={'search'}
                      label={t('PATIENT_TYPE.SEARCH')}
                      value={search}
                      onchange={(event) => {
                        setSearch(event.target.value)
                        setPage(1)
                      }}
                      onClear={(event) => {
                        setSearch('')
                        setPage(1)
                      }}
                    />
                  </Col>
                  <Col sm={12} md={6} xl={4} className="pl-md-0 pt-2">
                    <FilterSelect
                      onchange={(event) => {
                        const value = event.target.value
                        if (value) {
                          handleChangeStatus(value)
                          setPage(1)
                        }
                      }}
                      style={{ height: 40, width: '100%' }}
                      renderValue={() => `${t('STATUS.LABEL')}: ${t(`STATUS.${status}`)}`}
                      label={t('STATUS.LABEL')}
                      selectId="select-status"
                      value={status}
                      labelId="label-status"
                      options={[
                        <MenuItem key="1" value="ALL">
                          {t('STATUS.ALL')}
                        </MenuItem>,
                        <MenuItem key="2" value="ACTIVE">
                          {t('STATUS.ACTIVE')}
                        </MenuItem>,
                        <MenuItem key="3" value="INACTIVE">
                          {t('STATUS.INACTIVE')}
                        </MenuItem>
                      ]}
                    />
                  </Col>
                  <Col sm={12} md={6} xl={4} className="pl-md-0 pt-2">

                  </Col>
                </Row>
              </Col>
              <Col md={4} className="mt-2 mt-md-auto">
                <div className="pr-xl-2">
                  <ButtonCustom
                    mode="add"
                    disabled={permissions.isCreate.disabled}
                    onClick={() => {
                      resetForm()
                      setIsPopup(true)
                    }}
                    textButton={t('PATIENT_TYPE.BUTTON.ADD')}
                    className="w-auto ml-auto d-flex mt-auto" />
                </div>
              </Col>
            </Row>
          </Card.Title>

          <div className={'mt-3 pl-xl-3 pr-xl-2'}>
            <TableCustom
              page={page}
              pageLimit={pageLimit}
              sortType={sortType}
              sortBy={sortBy}
              onSort={onRequestSort}
              setPageLimit={handleChangeRowsPerPage}
              setPage={handleChangePage}
              rowCount={rowCount}
              headCells={headCells}
              rowsData={patientTypes.map((val, i) => {
                return renderData(val, i)
              })}
            />
          </div>
        </Card.Body>
      </Card> */}

      <PageModal
        title={patientTypeId ? t('PATIENT_TYPE.TITLE_UPDATE') : t('PATIENT_TYPE.TITLE_CREATE')}
        isOpen={isPopup}
        onCancel={{ onClick: () => resetForm() }}
        onSubmit={{ onClick: () => patientTypeId ? submitEdit() : submit() }}
        handleClose={resetForm}
        size={'XS'}
      >
        <Box className="py-2">
          {patientTypeId ? (
            <Form className="mx-0 mt-0 mb-3 p-0 d-inline-flex w-100">
              <Form.Label className=" mr-auto">{t('INPUT.LABEL_STATUS')}</Form.Label>
              <SwitchButton
                onChange={() => setPatientTypeStatus(patientTypeStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')}
                checked={patientTypeStatus === 'ACTIVE' ? true : false}
              />
            </Form>
          ) : (
            ''
          )}

          <Box display={'flex'} flexDirection={'column'} gap={'24px'}>
            <TextInput
              fullWidth
              onChange={(event) => {
                setPatientTypeName(event.target.value)
                clearErrorMessage()
              }}
              value={patientTypeName}
              label={t('PATIENT_TYPE.INPUT.PATIENT_TYPE_NAME')}
              helperText={
                errorMessage.PATIENT_TYPE_NAME ||
                errorMessage.IS_DUPLICATE_PATIENT_TYPE_NAME ||
                errorMessage.PATIENT_TYPE_NAME_STRING_BASE ||
                errorMessage.PATIENT_TYPE_NAME_STRING_EMPTY ||
                errorMessage.PATIENT_TYPE_NAME_MAXIMUM_LENGTH ||
                errorMessage.PATIENT_TYPE_NAME_ANY_REQUIRED
              }
              required={true}
            />
            <TextInput
              fullWidth
              onChange={(event) => {
                setPatientTypeNameEn(event.target.value)
                clearErrorMessage()
              }}
              value={patientTypeNameEn}
              helperText={
                errorMessage.PATIENT_TYPE_NAME_EN ||
                errorMessage.IS_DUPLICATE_PATIENT_TYPE_NAME_EN ||
                errorMessage.PATIENT_TYPE_NAME_EN_STRING_BASE ||
                errorMessage.PATIENT_TYPE_NAME_EN_STRING_EMPTY ||
                errorMessage.PATIENT_TYPE_NAME_EN_MAXIMUM_LENGTH ||
                errorMessage.PATIENT_TYPE_NAME_EN_ANY_REQUIRED
              }
              label={t('PATIENT_TYPE.INPUT.PATIENT_TYPE_NAME_EN')}
              required={false}
            />
            <Box borderBottom={1} width="100%" borderColor="#C5C5C5" />
            <SelectInput
              onChange={(e) => {
                setHasCondition(e.target.value)
                setDataOperative('')
                setDataOperativeTypes('')
              }}
              options={[
                { value: '0', name: 'ไม่มีเงื่อนไข' },
                { value: '1', name: 'เงื่อนไขอัตโนมัติตามจำนวนครั้งหัตถการ' }
              ]}
              label='เงื่อนไขเพิ่มเติม'
              value={hasCondition}
            />
            {hasCondition === "1" &&
              <>
                <SelectInput
                  onChange={(e) => {
                    setDataOperativeTypes(e.target.value)
                    setDataOperative('')
                    loadOperative(Number(e.target.value))
                  }}
                  options={_.map(operativeTypes, (item: any) => ({ value: item.operativeTypeId, name: item.operativeTypeName }))}
                  label='ประเภทหัตถการ'
                  value={dataOperativeTypes}
                  required
                  helperText={errorMessage.OPERATIVE_TYPE && !dataOperativeTypes ? errorMessage.OPERATIVE_TYPE : ''}
                />
                <SelectInput
                  onChange={(e) => setDataOperative(e.target.value)}
                  options={_.map(operative, (item: any) => ({ value: item.operativeId, name: item.operativeName }))}
                  label='รายการหัตถการ'
                  value={dataOperative}
                  required
                  disabled={dataOperativeTypes === ""}
                  helperText={errorMessage.OPERATIVE && !dataOperative ? errorMessage.OPERATIVE : ''}
                />
                <TextInput
                  onChange={(e: any) => {
                    setVisitCount(e.target.value)
                  }}
                  fullWidth
                  label='จำนวน'
                  required
                  numberOnly
                  value={visitCount}
                  disabled={dataOperativeTypes === ""}
                  helperText={errorMessage.VISITCOUNT && (!visitCount || visitCount === "0" || visitCount === 0) ? errorMessage.VISITCOUNT : ""}
                />
              </>
            }
          </Box>
        </Box>
      </PageModal>

    </div>
  )
}
